import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import * as XLSX from 'xlsx';
import * as React from 'react';
import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { getToken } from '../utils/common';
import moment from 'moment';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  Container,
  Typography,
  IconButton,
  TableContainer,
  Button,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogActions,
  TextField,
  TableHead,
  DialogContentText,
  DialogContent,
  Slide,
  Grid,
} from '@mui/material';
import { useTheme, styled, alpha } from '@mui/material/styles';
import Menu, { MenuProps } from '@mui/material/Menu';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
// components
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';

// sections
import { UserListHead, ReportListToolbar } from '../sections/@dashboard/user';
// mock
import USERLIST from '../_mock/rule';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'name', label: 'Report Name', alignRight: false },
  { id: 'acc', label: 'Created By', alignRight: false },
  { id: 'amount', label: 'Last Update', alignRight: false },
  { id: 'amount', label: 'Action', alignRight: false },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function UserPage() {
  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');
  const [datenext, setdatenext] = useState('');
  const [filterName, setFilterName] = useState('');
  const [data, setData] = useState([]);
  const [datadownload, setdatadownload] = useState([]);
  const [datestart, setdatestart] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [indexdata, setindexdata] = useState('');
  const [reportname, setreportname] = useState('');

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };

  const handledatenext = (newValue) => {
    setdatenext(newValue);
  };

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = USERLIST.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };
  const handledatestart = (newValue) => {
    setdatestart(newValue);
  };

  const handleFilterByName = (event) => {
    // setPage(0);https://kpk.smartshield.api.dev.chainsmart.id
    setFilterName(event.target.value);
    fetchInfo(window.REACT_APP_API_PURE + `report/list?report_name=${event.target.value}`);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - USERLIST.length) : 0;

  const filteredUsers = applySortFilter(USERLIST, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredUsers.length && !!filterName;

  const fetchInfo = (url) => {
    return fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getToken()}`,
      },
    })
      .then((res) => res.json())
      .then((d) => setData(d));
  };

  const fetchInfo2 = (url2) => {
    return fetch(url2, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getToken()}`,
      },
    })
      .then((res) => res.json())
      .then((d) => {
        // console.log(url2);
        // console.log(d);
        setdatadownload(d);
      });
  };

  const fetchInfo3 = (url2, reportName = '') => {
    return fetch(url2, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getToken()}`,
      },
    })
      .then((res) => res.json())
      .then((d) => {
        // console.log(url2);
        // console.log(d);
        if (d.data == null) {
          alert('Data Tidak Tersedia');
        }

        let stringifiedPerson = d.data;

        // if (reportName === ' New data record updates') {
        // let stringifiedPerson2 = d.data.map((item) => ({
        //   after: item.after,
        // }));
        // console.log(stringifiedPerson2);
        const worksheet = XLSX.utils.json_to_sheet(d.data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        XLSX.writeFile(workbook, 'result ' + `${reportName}.xlsx`);
        // } else if (
        //   reportName === 'Authorized data record changes' ||
        //   reportName === 'Unauthorized data record changes'
        // ) {
        //   let stringifiedPerson3 = d.data.map((item) => ({
        //     before: item.before,
        //     after: item.after,
        //   }));
        //   const worksheet = XLSX.utils.json_to_sheet(stringifiedPerson3);
        //   const workbook = XLSX.utils.book_new();
        //   XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        //   XLSX.writeFile(workbook, 'result ' + `${reportName}.xlsx`);
        // } else {
        //   let stringifiedPerson4 = d.data.map((item) => ({
        //     name: item.name,
        //     type: 'Data Integrity',
        //     date: moment.unix(item.created_at).format('YYYY-MM-DD HH:mm'),
        //     dataset: 'LHKPN',
        //     record_id: item.alert_id,
        //     status: item.status,
        //     severity: item.severity,
        //     result_alert: item.result_alert,
        //     owner_id: item.owner_id,
        //     action_note: item.action_note,
        //     before: item.before,
        //     after: item.after,
        //   }));
        //   const worksheet = XLSX.utils.json_to_sheet(stringifiedPerson4);
        //   const workbook = XLSX.utils.book_new();
        //   XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        //   XLSX.writeFile(workbook, 'result ' + `${reportName}.xlsx`);
        // }
      });
  };

  useEffect(() => {
    fetchInfo(window.REACT_APP_API_PURE + 'report/list');
    fetchInfo2(window.REACT_APP_API_PURE + 'alert/list');
    // downloadExcel();
  }, []);

  // /* eslint-disable */

  const downloadExcels = (filter, reportName) => {
    filter = indexdata;
    reportName = reportname;
    if (reportName == 'Active Alerts - All') {
      // alert('kesini');
      fetchInfo3(
        window.REACT_APP_API_PURE +
          `alert?status=open&status=inProgress&status=pendingApproval&status=pendingRollback&limit=1000000000&from=${new Date(
            datestart
          ).toISOString()}&to=${new Date(datenext).toISOString()}&rangeType=createdAt`,
        reportName
      );
    } else if (reportName == 'Active Alerts - Open') {
      fetchInfo3(
        window.REACT_APP_API_PURE +
          `alert?status=open&limit=1000000000&from=${new Date(datestart).toISOString()}&to=${new Date(
            datenext
          ).toISOString()}&rangeType=createdAt`,
        reportName
      );
    } else if (reportName == 'Active Alerts - In Progress') {
      fetchInfo3(
        window.REACT_APP_API_PURE +
          `alert?status=inProgress&limit=1000000000&from=${new Date(datestart).toISOString()}&to=${new Date(
            datenext
          ).toISOString()}&rangeType=createdAt`,
        reportName
      );
    } else if (reportName == 'Active Alerts - Pending Approval') {
      fetchInfo3(
        window.REACT_APP_API_PURE +
          `alert?status=pendingApproval&limit=1000000000&from=${new Date(datestart).toISOString()}&to=${new Date(
            datenext
          ).toISOString()}&rangeType=createdAt`,
        reportName
      );
    } else if (reportName == 'Active Alerts - Pending Rollbacks') {
      fetchInfo3(
        window.REACT_APP_API_PURE +
          `alert?status=pendingRollback&limit=1000000000&from=${new Date(datestart).toISOString()}&to=${new Date(
            datenext
          ).toISOString()}&rangeType=createdAt`,
        reportName
      );
    } else if (reportName == 'Processed Alerts - All') {
      fetchInfo3(
        window.REACT_APP_API_PURE +
          `alert?status=closed&limit=1000000000&from=${new Date(datestart).toISOString()}&to=${new Date(
            datenext
          ).toISOString()}&rangeType=createdAt`,
        reportName
      );
    } else if (reportName == 'Processed Alerts - Rolled Back') {
      fetchInfo3(
        window.REACT_APP_API_PURE +
          `alert?status=closed&closedStatus=rollback&limit=1000000000&from=${new Date(
            datestart
          ).toISOString()}&to=${new Date(datenext).toISOString()}&rangeType=createdAt`,
        reportName
      );
    } else if (reportName == 'Processed Alerts - Kept') {
      fetchInfo3(
        window.REACT_APP_API_PURE +
          `alert?status=closed&closedStatus=keep&limit=1000000000&from=${new Date(
            datestart
          ).toISOString()}&to=${new Date(datenext).toISOString()}&rangeType=createdAt`,
        reportName
      );
    } else if (reportName == 'Web Verification') {
      const url =
        window.REACT_APP_API_PURE +
        `report/interactive-verify?from=${new Date(datestart).toISOString()}&to=${new Date(datenext).toISOString()}`;
      const link = document.createElement('a');
      link.href = url;
      link.download = reportName;
      const xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.setRequestHeader('Authorization', `Bearer ${getToken()}`);
      xhr.responseType = 'blob';

      xhr.onload = function () {
        if (this.status === 200) {
          const blob = new Blob([xhr.response], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          const blobUrl = URL.createObjectURL(blob);
          link.href = blobUrl;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(blobUrl);
        }
      };
      xhr.send();
    }else if (reportName == 'Unauthorized Updates') {
      const url =
        window.REACT_APP_API_PURE +
        `report/unauthorized-update?from=${new Date(datestart).toISOString()}&to=${new Date(datenext).toISOString()}`;
      const link = document.createElement('a');
      link.href = url;
      link.download = reportName;
      const xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.setRequestHeader('Authorization', `Bearer ${getToken()}`);
      xhr.responseType = 'blob';

      xhr.onload = function () {
        if (this.status === 200) {
          const blob = new Blob([xhr.response], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          const blobUrl = URL.createObjectURL(blob);
          link.href = blobUrl;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(blobUrl);
        }
      };
      xhr.send();
    } else if (reportName == 'Authorized Updates') {
      // fetchInfo3(
      //   window.REACT_APP_API_PURE +`report/authorized-update?from=${new Date(
      //     datestart
      //   ).toISOString()}&to=${new Date(datenext).toISOString()}`
      // )
      const url =
        window.REACT_APP_API_PURE +
        `report/authorized-update?from=${new Date(datestart).toISOString()}&to=${new Date(datenext).toISOString()}`;
      const link = document.createElement('a');
      link.href = url;
      link.download = reportName;
      const xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.setRequestHeader('Authorization', `Bearer ${getToken()}`);
      xhr.responseType = 'blob';

      xhr.onload = function () {
        if (this.status === 200) {
          const blob = new Blob([xhr.response], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          const blobUrl = URL.createObjectURL(blob);
          link.href = blobUrl;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(blobUrl);
        }
      };
      xhr.send();
    } else if (reportName == 'Web Verification') {
      const url =
        window.REACT_APP_API_PURE +
        `report/interactive-verify?from=${new Date(datestart).toISOString()}&to=${new Date(datenext).toISOString()}`;
      const link = document.createElement('a');
      link.href = url;
      link.download = reportName;
      const xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.setRequestHeader('Authorization', `Bearer ${getToken()}`);
      xhr.responseType = 'blob';

      xhr.onload = function () {
        if (this.status === 200) {
          const blob = new Blob([xhr.response], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          const blobUrl = URL.createObjectURL(blob);
          link.href = blobUrl;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(blobUrl);
        }
      };
      xhr.send();
    }
  };
 const StyledTableCell = styled(TableCell)(({ theme }) => ({
   [`&.${tableCellClasses.head}`]: {
     backgroundColor: theme.palette.primary.dark,
     color: theme.palette.common.white,
   },
   [`&.${tableCellClasses.body}`]: {
     fontSize: 14,
   },
 }));

 const { t } = useTranslation();

 function handleClickLang(lang) {
   i18next.changeLanguage(lang);
 }
 const StyledMenu = styled((props) => (
   <Menu
     elevation={0}
     anchorOrigin={{
       vertical: 'bottom',
       horizontal: 'right',
     }}
     transformOrigin={{
       vertical: 'top',
       horizontal: 'right',
     }}
     {...props}
   />
 ))(({ theme }) => ({
   '& .MuiPaper-root': {
     borderRadius: 6,
     marginTop: theme.spacing(1),
     minWidth: 180,
     color: theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
     boxShadow:
       'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
     '& .MuiMenu-list': {
       padding: '4px 0',
     },
     '& .MuiMenuItem-root': {
       '& .MuiSvgIcon-root': {
         fontSize: 18,
         color: theme.palette.text.secondary,
         marginRight: theme.spacing(1.5),
       },
       '&:active': {
         backgroundColor: alpha(theme.palette.secondary.main, theme.palette.action.selectedOpacity),
       },
     },
   },
 }));
  /* eslint-enable */
  return (
    <>
      <Helmet>
        <title> Report List | SmartShield </title>
      </Helmet>
      <Dialog
        open={open}
        // TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        maxWidth={'md'}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{t('GenerateReport.2')}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <Grid container direction={'row'} spacing={2}>
              <Grid item alignSelf={'center'}>
                <Typography>{t('GenerateReport.3')} : </Typography>
              </Grid>
              <Grid item>
                {' '}
                <div>
                  {' '}
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      onChange={handledatestart}
                      value={datestart}
                      renderInput={(params) => <TextField size="small" fullWidth {...params} />}
                    />
                  </LocalizationProvider>
                </div>
              </Grid>
              <Grid item alignSelf={'center'}>
                <Typography>{t('GenerateReport.4')} </Typography>
              </Grid>
              <Grid item>
                {' '}
                <div>
                  {' '}
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      onChange={handledatenext}
                      value={datenext}
                      renderInput={(params) => <TextField size="small" fullWidth {...params} />}
                    />
                  </LocalizationProvider>
                </div>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{t('Close.1')}</Button>
          <Button onClick={downloadExcels}>{t('SubmitButton.1')}</Button>
        </DialogActions>
      </Dialog>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Report
          </Typography>
          {/* onClick={() => {
                Router.push("/home/report/add");
              }} */}
          {/* <Link
            to={{
              pathname: `/dashboard/report/add`,
            }}
          > */}
          {/* <Button onClick={downloadExcel} variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}>
            Generate Report
          </Button> */}
          {/* </Link> */}
        </Stack>

        <Card>
          <ReportListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <TableHead>
                  <TableRow className="custom-table-row">
                    <StyledTableCell style={{ backgroundColor: '#E2F5FC', color: '#0E7496' }}>
                      {t('Nomor.1')}
                    </StyledTableCell>
                    <StyledTableCell style={{ backgroundColor: '#E2F5FC', color: '#0E7496' }}>
                      {t('ReportName.1')}
                    </StyledTableCell>
                    <StyledTableCell style={{ backgroundColor: '#E2F5FC', color: '#0E7496' }}>
                      {t('CreatedBy.1')}
                    </StyledTableCell>
                    <StyledTableCell style={{ backgroundColor: '#E2F5FC', color: '#0E7496' }}>
                      {t('LastUpdate.1')}
                    </StyledTableCell>
                    <StyledTableCell style={{ backgroundColor: '#E2F5FC', color: '#0E7496' }}>
                      {t('Actions.2')}
                    </StyledTableCell>
                    <StyledTableCell style={{ backgroundColor: '#E2F5FC', color: '#0E7496' }}> </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data?.data?.map((index, row, dataObj) => {
                    const dateString = moment.unix(index.created_at).format('YYYY-MM-DD HH:mm');
                    return (
                      <TableRow hover key={row}>
                        <TableCell component="th" scope="row" alignItems="center">
                          {row + 1}
                        </TableCell>
                        <TableCell component="th" scope="row" padding="none">
                          {index.report_name}
                        </TableCell>
                        <TableCell component="th" scope="row" padding="none">
                          smartshield
                        </TableCell>
                        <TableCell component="th" scope="row" padding="none">
                          {dateString}
                        </TableCell>
                        <TableCell component="th" scope="row" padding="none">
                          <Button
                            style={{ backgroundColor: 'rgb(79, 138, 226)' }}
                            size="small"
                            onClick={() => {
                              setreportname(index.report_name);
                              setindexdata(index?.filter);
                              handleClickOpen();
                            }}
                            variant="contained"
                            startIcon={<Iconify icon="eva:plus-fill" />}
                          >
                            {t('GenerateReport.1')}
                          </Button>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {/* {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Not found
                          </Typography>

                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete words.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )} */}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={USERLIST.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
      {/* 
      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem>
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Process
        </MenuItem>
      </Popover> */}
    </>
  );
}
